export default __webpack_public_path__ + "static/media/courier-tracking-motor-bike.e4b3be6d.svg";